










































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'

import { Brand, Point, Campaign, Permissions } from '../store/timeline'
import DateField from './DateField.vue'
import TimeField from './TimeField.vue'

function emptyPoint(type: string): Point {
    return {
        id: null,
        title: '',
        type,
        brand_id: null,
        belongs_to: [],
        campaign_id: null,
        date: null,
        time: null,
        subscribed: false,
    }
}

@Component({
    props: {
        type: {
            type: String,
            default: '',
        },
        pointId: {
            type: String,
            required: true,
        },
    },
    components: {
        DateField,
        TimeField,
    },
})
export default class PointDialog extends Vue {
    @State(s => s.timeline.brands) brands!: Brand[]
    @State(s => s.timeline.campaigns) campaigns!: Campaign[]
    @State(s => s.timeline.userSettings.permissions) permissions!: Permissions

    pointId!: string
    type!: string

    valid = true
    visible = true
    activeTab = null

    editing = false
    subscribing = false

    obj = emptyPoint('undefined')

    titleRules = [
        (v: any) => v ? true : 'This field is required',
        (v: string) => v.length <= 50 ? true : 'Title must be no longer than 50 characters',
    ]

    requiredRules = [
        (v: any) => v !== null ? true : 'This field is required',
    ]

    async mounted() {
        if (this.pointId === '0') {
            this.obj = emptyPoint(this.type)
            this.editing = true
        } else {
            await this.reload()
        }
    }

    async reload() {
        const response = await this.$store.dispatch('api/get', {
            path: `point/${this.pointId}`,
        })
        this.obj = response.data
    }

    close() {
        this.$router.push({ name: 'home' })
    }

    edit() {
        this.editing = true
    }

    async save() {
        let form: any = this.$refs.form
        if (form.validate()) {
            this.editing = false
            if (this.obj!.id === null) {
                await this.create()
            } else {
                await this.update()
            }
        }
    }

    async cancel() {
        this.editing = false
        if (this.obj!.id === null) {
            this.close()
        } else {
            await this.reload()
            this.valid = true
        }
    }

    async create() {
        const response = await this.$store.dispatch('api/post', {
            path: 'point',
            data: this.obj,
        })
        this.obj = response.data
        // FIXME this is only temporary while there is no incremental
        // reload implemented
        this.close()
        await this.$store.dispatch('timeline/loadEntries')
    }

    async update() {
        const response = await this.$store.dispatch('api/patch', {
            path: `point/${this.pointId}`,
            data: this.obj,
        })
        this.obj = response.data
        // FIXME this is only temporary while there is no incremental
        // reload implemented
        this.close()
        await this.$store.dispatch('timeline/loadEntries')
    }

    async deleteObj() {
        try {
            await this.$store.dispatch('api/delete', {
                path: `point/${this.pointId}`,
                data: this.obj,
            })
        } catch (e) {
            // FIXME add some error handling
            console.log('delete failed', e)
        }
        // FIXME this is only temporary while there is no incremental
        // reload implemented
        this.close()
        await this.$store.dispatch('timeline/loadEntries')
    }

    get brandCampaigns(): Campaign[] {
        if (this.obj.brand_id) {
            return this.campaigns.filter(c => c.brand_id === this.obj.brand_id)
        } else {
            return this.campaigns
        }
    }

    @Watch('brandCampaigns')
    watchBrandCampaigns() {
        if (!this.brandCampaigns.find(d => d.id === this.obj.brand_id)) {
            this.obj.campaign_id = null
        }
    }

    async toggle_subscription() {
        const action = this.obj.subscribed ? 'unsubscribe' : 'subscribe'
        this.subscribing = true
        try {
            const response = await this.$store.dispatch('api/post', {
                path: `point/${this.pointId}/${action}`,
            })
            this.obj.subscribed = !this.obj.subscribed
        } finally {
            this.subscribing = false
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PointDialog.vue